import { httpClient } from '@/shared/api/httpClient';
import {
  Profile,
  VerificationCodeRequestResult,
} from '@/shared/types/certificate-request';

export const contactApi = {
  async sendVerificationCode(): Promise<VerificationCodeRequestResult> {
    const { data } = await httpClient.post<VerificationCodeRequestResult>('/contact/code');
    return data;
  },

  async verifyCode(code: string): Promise<Profile> {
    const { data } = await httpClient.post<Profile>('/contact/code/verify', { code });
    return data;
  },
};
